<template>
	<v-form ref="emailForm">
		<v-row no-gutters>
      <v-col cols="12" v-if="!email.automatic">
				<v-text-field
					v-model="email.description"
					label="Descrição"
					outlined
					:rules="[required]"
				/>
			</v-col>
			<v-col cols="12">
				<v-text-field
					v-model="email.subject_pt"
					label="Assunto PT"
					outlined
					:rules="[required]"
				/>
			</v-col>
			<v-col cols="12">
				<v-text-field
					v-model="email.subject_en"
					label="Assunto EN"
					outlined
					:rules="[required]"
				/>
			</v-col>
			<v-col cols="12">
				<v-text-field
					v-model="email.subject_es"
					label="Assunto ES"
					outlined
					:rules="[required]"
				/>
			</v-col>
			<v-col cols="12">
				Corpo PT
				<RichTextEditor key="pt-body" ref="bodyPT" :text="email.body_pt" />
			</v-col>
			<v-col cols="12">
				Corpo EN
				<RichTextEditor key="en-body" ref="bodyEN" :text="email.body_en" />
			</v-col>
			<v-col cols="12">
				Corpo ES
				<RichTextEditor key="es-body" ref="bodyES" :text="email.body_es" />
			</v-col>
			<template v-if="isSMS">
				<p class="text-h6 mt-5">SMS</p>
				<v-col cols="12">
					<v-textarea outlined label="SMS PT" v-model="email.sms_pt" class="mt-5" />
				</v-col>
				<v-col cols="12">
					<v-textarea outlined label="SMS EN" v-model="email.sms_en" class="mt-5" />
				</v-col>
				<v-col cols="12">
					<v-textarea outlined label="SMS ES" v-model="email.sms_es" class="mt-5" />
				</v-col>
			</template>
		</v-row>
	</v-form>
</template>

<script>
import RichTextEditor from "@/components/RichTextEditor.vue";

export default {
	name: "EmailForm",
	props: ["email", "isSMS"],
	components: {
		RichTextEditor
	},
	data: () => ({}),
	computed: {
		required() {
			return value => !!value || this.$gettext("Required.");
		}
	},
	methods: {
		getForm() {
			if (this.$refs.emailForm.validate()) {
				const form = new FormData();
				form.append("description", this.email.description);
				form.append("subject_pt", this.email.subject_pt);
				form.append("subject_en", this.email.subject_en);
				form.append("subject_es", this.email.subject_es);
				form.append("body_pt", this.$refs.bodyPT.getHTML());
				form.append("body_en", this.$refs.bodyEN.getHTML());
				form.append("body_es", this.$refs.bodyES.getHTML());
				if (this.email.sms_pt) form.append("sms_pt", this.email.sms_pt);
				if (this.email.sms_en) form.append("sms_en", this.email.sms_en);
				if (this.email.sms_es) form.append("sms_es", this.email.sms_es);
				return form;
			}

			return null;
		}
	}
};
</script>